import * as React from "react";
import { useParams } from "react-router";
import { BulkExportProvider } from "./providers";
import { SnackBarBulkExportBASF } from "./components/SnackBarBulkExportBASF";
import { DownloadFile } from "./components/DownloadFile";

export const DownloadFileRoot: React.FC = (props) => {
  const params = useParams();
  const fileKey = params["fileKey"];
  return (
    <>
      <BulkExportProvider>
        <DownloadFile fileKey={fileKey} />
      </BulkExportProvider>
      <SnackBarBulkExportBASF />
    </>
  );
};
